

























import { defineComponent, ref } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { format } from "@/lib/time";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm/BaseForm.vue";

export default defineComponent({
  name: "SensitiveContentSetupAge",
  components: { BaseForm, BaseConfirm, BaseButton },
  props: {
    birthDate: { type: [String, Date] },
  },
  setup(props, { emit }) {
    const loadingConfirm = ref(false);
    const loadingDecline = ref(false);
    const isValid = ref(false);
    const values = ref<FormValues>({
      birthDate: props.birthDate ? format(new Date(props.birthDate), "yyyy-MM-dd") : undefined,
    });
    const fields: FormFields = [
      {
        name: "birthDate",
        label: $t("Birth date"),
        type: "date",
        min: new Date(1900, 0),
        max: new Date(),
      },
    ];

    const decline = () => {
      loadingDecline.value = true;
      emit("submit", null, () => (loadingDecline.value = false));
    };

    const submit = () => {
      loadingConfirm.value = true;
      const { birthDate } = values.value;
      emit("submit", birthDate, () => (loadingConfirm.value = false));
    };
    return { loadingConfirm, loadingDecline, fields, values, isValid, submit, decline };
  },
});
